import { fr } from "../i18n/fr.js";
import { escape } from "./format.js";

export function renderRefusal(reasons: readonly string[]): string {
  return `<div class="verlet-refusal" role="note"><p class="verlet-refusal__title">${escape(fr.comparisonRefused)}</p><ul>${reasons.map((reason) => `<li>${escape(reason)}</li>`).join("")}</ul></div>`;
}
